import LxcError from "~/core/models/LxcError.class";
import type { DtwinLifeCycleState } from "~/modules/dtwin/models/DtwinLifeCycleState.enum";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export function useUpdateDtwinLifeCycleState({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function updateDtwinLifeCycleState(
    newLifeCycleState: DtwinLifeCycleState,
    dtwinUid: string,
  ) {
    error.value = undefined;
    isLoading.value = true;

    const response = await dtwinsService.updateOrganizationDtwinLifeCycleState(
      dtwinUid,
      newLifeCycleState,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    updateDtwinLifeCycleState,
  };
}
